import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import User from '../entities/user'
import Role from '../entities/role'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'

interface UserState extends ListState<User> {
    editUser: User,
    roles: Role[]
}
class UserMutations extends ListMutations<User>{

}
class UserModule extends ListModule<UserState, any, User>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<User>(),
        loading: false,
        editUser: new User(),
        roles: new Array<Role>()
    }
    actions = {
        async getAgencyUsers(context: ActionContext<UserState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Admin/GetAgencyUsers', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<User>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async createUser(context: ActionContext<UserState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.post('/api/services/app/Admin/CreateAgencyUser', payload.data);
            context.state.loading = false;
            return response.data;
        },
        async updateUser(context: ActionContext<UserState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.put('/api/services/app/Admin/UpdateAgencyUser', payload.data);
            context.state.loading = false;
            return response.data;
        },
        async resetUserPassword(context: ActionContext<UserState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.post('/api/services/app/Admin/ResetAgencyUserPassword', payload.data);
            context.state.loading = false;
            return response.data;
        },
        async deleteUser(context: ActionContext<UserState, any>, payload: any) {
            let response =   await Ajax.delete('/api/services/app/Admin/DeleteAgencyUser?input=' + payload.data.id);          
            return response.data;
        },
        
    };
    mutations = {
        setCurrentPage(state: UserState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: UserState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: UserState, user: User) {
            state.editUser = user;
        }
    }
}
const userModule = new UserModule();
export default userModule;